module.exports = __webpack_public_path__ + "static/img/iq.fb484ddc.svg";